import React, { useState, useEffect } from "react";
import "./NavBar.css";
import MenuIcon from '@material-ui/icons/Menu';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { Link } from 'react-router-dom';
import { Button, FormControl, Input, InputLabel, FormHelperText } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';


function NavBar({page}) {
	const [homePageFood, setHomePageFood] = useState([]);
	const [payment, setPayment] = useState(false);
	const [foodCart, setFoodCart] = useState([]);

	const showPayment = () => {
		const paymentWindow = document.querySelector(".home__foodCartCheckoutfinal");
		paymentWindow.classList.toggle("home__activeFoodCartCheckoutfinal");
		setPayment(!payment)
	} 

	const activeMenu = () => {
		const navBarNavLinks = document.querySelector(".navBar__navLinks");

		navBarNavLinks.classList.toggle("navBar__activeNavLinks");
	}

	const activeFoodCart = () => {
		const homeFoodCart = document.querySelector(".home__foodCart");

		homeFoodCart.classList.toggle("home__activeFoodCart")
	}

	const currentPageStyles = {
		border: "2px solid #fff",
		padding: "5px 12px",
		textDecoration: "none",
		color: "#fff"
	}

	const offersCurrentPageStyles = {
		border: "2px solid #000",
		padding: "5px 12px",
		textDecoration: "none",
		color: "#000"
	}


	return (
		<div className="navBar">
			<h1 className="navBar__Title" style={page === "offers" ? {color: "#000"} : {color: "#fff"}}> 5 Star Restaurant </h1>
			<div className="navBar__navLinks">
				<Link to="/" className={page === "offers" ? "navLinkBlck" : "navLinksWhite"} style={page === "home" ? currentPageStyles : {textDecoration: "none"}}>
					<div> Home </div>
				</Link>
				<Link to="/Menu" className={page === "offers" ? "navLinkBlck" : "navLinksWhite"} style={page === "menu" ? currentPageStyles : {textDecoration: "none"}}>
					<div> Menu </div>
				</Link>
				<Link to="/AboutUs" className={page === "offers" ? "navLinkBlck" : "navLinksWhite"} style={page === "aboutUs" ? currentPageStyles : {textDecoration: "none"}}>
					<div> About Us </div>
				</Link>
				<Link to="/ContactUs" className={page === "offers" ? "navLinkBlck" : "navLinksWhite"} style={page === "contactUs" ? currentPageStyles : {textDecoration: "none"}}>
					<div> Contact Us </div>
				</Link>
				<Link to="/Offers" className={page === "offers" ? "navLinkBlck" : "navLinksWhite"} style={page === "offers" ? offersCurrentPageStyles : {textDecoration: "none"}}>
					<div> Offers </div>
				</Link>
				<ShoppingCartIcon style={page === "home" || page === "menu" ? {display: "block"}: {display: "none"}} onClick={activeFoodCart}/>
			</div>
				<MenuIcon className="navBar__burgerMenu" onClick={activeMenu}/>

			
		</div>
	)
}

export default NavBar;